import type {Gsoa_ProductCatalog_ProductDetail as ProductDetail} from '~/openapi';

export const useNormilizeHouseProductSlug = () => {
	const router = useRouter();
	const route = useRoute();

	return async (product: ProductDetail | null | undefined) => {
		const {product: productSlug} = route.params;

		if (!productSlug || typeof productSlug !== 'string' || !product) {
			return;
		}

		const normalizedSlug = createHouseProductSlug(product);

		// If slug is already correct, do nothing
		if (productSlug === normalizedSlug) {
			return;
		}

		// Replace current route with normalized slug (no server redirect, no history entry)
		await router.replace({
			name: route.name ?? undefined,
			params: {
				...route.params,
				product: normalizedSlug,
			},
			query: route.query,
			hash: route.hash,
		});
	};
};
